import { render, staticRenderFns } from "./formStoreCategory.vue?vue&type=template&id=72759a37&scoped=true"
import script from "./formStoreCategory.vue?vue&type=script&lang=js"
export * from "./formStoreCategory.vue?vue&type=script&lang=js"
import style0 from "./formStoreCategory.vue?vue&type=style&index=0&id=72759a37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72759a37",
  null
  
)

export default component.exports